
/**
 * Image with Caption Constants
 * @module patterns/components/form-and-content/rich-text/image-with-caption
 */


/**
 * Class to style and load the carousel
 */
export const CLASS_NAME = 'image-with-caption-carousel';

/**
 * Options for the modal carousel.
 */
export const OPTIONS = {
    gap: 0,
    classes: {
        direction: {
            ltr: 'carousel--ltr',
            rtl: 'carousel--rtl',
        },
        slider: 'carousel--slider',
        carousel: 'carousel--carousel',
        swipeable: 'carousel--swipeable',
        dragging: 'carousel--dragging',
        cloneSlide: 'carousel--clone',
        activeNav: 'carousel__bullet--active',
        activeSlide: 'carousel__slide--active',
        disabledArrow: 'carousel--disabled',
    },
};
